import { render, staticRenderFns } from "./MlbbBroadcastPage.vue?vue&type=template&id=5bdd76ee&scoped=true"
import script from "./MlbbBroadcastPage.vue?vue&type=script&lang=js"
export * from "./MlbbBroadcastPage.vue?vue&type=script&lang=js"
import style0 from "./MlbbBroadcastPage.vue?vue&type=style&index=0&id=5bdd76ee&prod&scoped=true&lang=scss"
import style1 from "./MlbbBroadcastPage.vue?vue&type=style&index=1&id=5bdd76ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdd76ee",
  null
  
)

export default component.exports